export class UserStatsView {
    public collected_coins: number = 0;
    public dropzones_visited: number = 0;
    public collected_bags: number = 0;
    public collected_garbage: number = 0;

    constructor() {}
}
